// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fot1","content":"styles_content__3HHEE"};